import { type vec2 } from 'gl-matrix';

import { type TileMap } from './tiling';

const truthy = () => true;

export class TileSearcher<T> {
  constructor(private map: TileMap<T>) {}

  /**
   * Computes ids for all of the elements which are in the tiles which a
   * supplied element belongs to.
   * @param id the element being queried
   * @returns a list of tiles
   */
  public getElementsNearby(id: T, predicate: (id: T) => boolean = truthy) {
    const ids = new Set<T>();
    const tiles = this.map.get(id);

    if (!tiles) {
      return ids;
    }

    for (const tile of tiles) {
      const elementIds = this.map.getElements(tile);
      if (!elementIds) {
        continue;
      }

      for (const elementId of elementIds) {
        if (id === elementId) {
          continue;
        }

        const valid = predicate(elementId);
        if (!valid) {
          continue;
        }

        ids.add(elementId);
      }
    }

    return ids;
  }

  public getElementsContainingPoint(point: vec2, result = new Set<T>()) {
    return this.map.getElementsContainingPoint(point, result);
  }
}
